import initHhBanner from '../../js/hh-banner.js';
import initCoverCarouselCounter from '../../js/cover-carousel-counter.js';

initHhBanner();

function initAfterLegacyScripts() {
    initCoverCarouselCounter();
}

if (document.readyState === 'complete') {
    initAfterLegacyScripts();
} else {
    window.addEventListener('load', initAfterLegacyScripts);
}



// WEBPACK FOOTER //
// ./_src/pages/main/index.js